import React, { useState, useEffect } from "react";
import DeliveryDateSelection from "./DeliveryDateSelection.Component";

export default function DeliveryDate({
  Address,
  time,
  date,
  toggleModal,
  errorNotify,
  requireDeliveryDate,
  parent,
  config,
  onSendNowChange,
  type,
}) {
  const [sendNow, setSendNow] = useState(true);
  useEffect(() => {
    if (!requireDeliveryDate) return;
    if (typeof onSendNowChange === "function") {
      onSendNowChange(sendNow);
    }
  }, [sendNow, requireDeliveryDate]);

  return (
    <div className="flex-column w-100">
      {!config?.default && config?.displaySendNow && (
        <div>
          <p className="font-weight-bold">When should we send your product?</p>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="sendNow"
              id="sendNow1"
              value={true}
              checked={sendNow}
              onChange={() => setSendNow(true)}
            />
            <label className="form-check-label" htmlFor="sendNow1">
              Send it now 📬
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="sendNow"
              id="sendNow2"
              value={false}
              checked={!sendNow}
              onChange={() => setSendNow(false)}
            />
            <label className="form-check-label" htmlFor="sendNow2">
              Schedule it for later 📅
            </label>
          </div>
          <p className="my-3 text-black-50">
            {sendNow ? config?.sendNowText : config?.sendLaterText}
          </p>
        </div>
      )}
      {(config?.default || !sendNow) && (
        <DeliveryDateSelection
          Address={Address}
          time={time}
          date={date}
          toggleModal={toggleModal}
          errorNotify={errorNotify}
          parent={parent}
          config={config}
          type={type}
        />
      )}
    </div>
  );
}
